// extracted by mini-css-extract-plugin
export default {"label":"label--AYVKPNgb92","date":"date--GnvGaYRxle"};